import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ef61db6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-10 py-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-400 ml-1" }, "Загрузка данных...", -1))
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-red-400" }, "При получении данных произошла ошибка", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Для активации услуги, количество должно быть "),
  /*#__PURE__*/_createElementVNode("u", null, "больше 0")
], -1))
const _hoisted_9 = { class: "mt-3" }
const _hoisted_10 = { class: "service" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none ml-3" }, "Грузчики", -1))
const _hoisted_13 = { class: "service" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none ml-3" }, "Манипулятор", -1))
const _hoisted_16 = { class: "service" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none ml-3" }, "Кран", -1))
const _hoisted_19 = { class: "service" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none ml-3" }, "Машина", -1))
const _hoisted_22 = { class: "service" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none ml-3" }, "Рохля", -1))
const _hoisted_25 = { class: "service" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none ml-3" }, "Паллета", -1))
const _hoisted_28 = { class: "service" }
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none ml-3" }, "Мягкая упаковка", -1))
const _hoisted_31 = { class: "service" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-none ml-3" }, "Обрешетка", -1))
const _hoisted_34 = { class: "flex items-center justify-end mt-2" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_loader = _resolveComponent("loader")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: _ctx.pageTitle }, null, 8, ["title"]),
      _createVNode(_component_router_link, {
        to: `/invoice/${_ctx.$route.params.invoice_id}`
      }, {
        default: _withCtx(() => [
          _createVNode(_component_the_button, { class: "second small text" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" Вернуться к накладной ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("form", {
      class: "bg-white border py-4 px-6 mt-6",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updateAdditionalServices && _ctx.updateAdditionalServices(...args)), ["prevent"]))
    }, [
      (_ctx.state.is_loading || _ctx.state.is_failed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_5
                ]))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_the_button, {
                      class: "primary small mt-1",
                      type: "button",
                      onClick: _ctx.loadInvoice
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перезагрузить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, [
                  _createVNode(_component_checkbox, {
                    disabled: true,
                    value: _ctx.additional_services_state.loadersCount > 0
                  }, null, 8, ["value"]),
                  _hoisted_12
                ]),
                _createVNode(_component_the_input, {
                  disabled: _ctx.additional_services_state.is_loading,
                  value: _ctx.additional_services_state.loadersCount,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.additional_services_state.loadersCount) = $event)),
                  "is-invalid": _ctx.additional_services_state_form$.loadersCount.$error,
                  placeholder: "Количество"
                }, null, 8, ["disabled", "value", "is-invalid"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, [
                  _createVNode(_component_checkbox, {
                    disabled: true,
                    value: _ctx.additional_services_state.manipulatorCount > 0
                  }, null, 8, ["value"]),
                  _hoisted_15
                ]),
                _createVNode(_component_the_input, {
                  disabled: _ctx.additional_services_state.is_loading,
                  value: _ctx.additional_services_state.manipulatorCount,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.additional_services_state.manipulatorCount) = $event)),
                  "is-invalid": _ctx.additional_services_state_form$.manipulatorCount.$error,
                  placeholder: "Количество"
                }, null, 8, ["disabled", "value", "is-invalid"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, [
                  _createVNode(_component_checkbox, {
                    disabled: true,
                    value: _ctx.additional_services_state.craneCount > 0
                  }, null, 8, ["value"]),
                  _hoisted_18
                ]),
                _createVNode(_component_the_input, {
                  disabled: _ctx.additional_services_state.is_loading,
                  value: _ctx.additional_services_state.craneCount,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.additional_services_state.craneCount) = $event)),
                  "is-invalid": _ctx.additional_services_state_form$.craneCount.$error,
                  placeholder: "Количество"
                }, null, 8, ["disabled", "value", "is-invalid"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, [
                  _createVNode(_component_checkbox, {
                    disabled: true,
                    value: _ctx.additional_services_state.carCount > 0
                  }, null, 8, ["value"]),
                  _hoisted_21
                ]),
                _createVNode(_component_the_input, {
                  disabled: _ctx.additional_services_state.is_loading,
                  value: _ctx.additional_services_state.carCount,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.additional_services_state.carCount) = $event)),
                  "is-invalid": _ctx.additional_services_state_form$.carCount.$error,
                  placeholder: "Количество"
                }, null, 8, ["disabled", "value", "is-invalid"])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("label", _hoisted_23, [
                  _createVNode(_component_checkbox, {
                    disabled: true,
                    value: _ctx.additional_services_state.hydraulicTrolleyCount > 0
                  }, null, 8, ["value"]),
                  _hoisted_24
                ]),
                _createVNode(_component_the_input, {
                  disabled: _ctx.additional_services_state.is_loading,
                  value: _ctx.additional_services_state.hydraulicTrolleyCount,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.additional_services_state.hydraulicTrolleyCount) = $event)),
                  "is-invalid": 
                                _ctx.additional_services_state_form$.hydraulicTrolleyCount.$error
                            ,
                  placeholder: "Количество"
                }, null, 8, ["disabled", "value", "is-invalid"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, [
                  _createVNode(_component_checkbox, {
                    disabled: true,
                    value: _ctx.additional_services_state.palletCount > 0
                  }, null, 8, ["value"]),
                  _hoisted_27
                ]),
                _createVNode(_component_the_input, {
                  disabled: _ctx.additional_services_state.is_loading,
                  value: _ctx.additional_services_state.palletCount,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.additional_services_state.palletCount) = $event)),
                  "is-invalid": _ctx.additional_services_state_form$.palletCount.$error,
                  placeholder: "Количество"
                }, null, 8, ["disabled", "value", "is-invalid"])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, [
                  _createVNode(_component_checkbox, {
                    disabled: true,
                    value: _ctx.additional_services_state.softPackageCount > 0
                  }, null, 8, ["value"]),
                  _hoisted_30
                ]),
                _createVNode(_component_the_input, {
                  disabled: _ctx.additional_services_state.is_loading,
                  value: _ctx.additional_services_state.softPackageCount,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.additional_services_state.softPackageCount) = $event)),
                  "is-invalid": _ctx.additional_services_state_form$.softPackageCount.$error,
                  placeholder: "Количество"
                }, null, 8, ["disabled", "value", "is-invalid"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, [
                  _createVNode(_component_checkbox, {
                    disabled: true,
                    value: _ctx.additional_services_state.gridCount > 0
                  }, null, 8, ["value"]),
                  _hoisted_33
                ]),
                _createVNode(_component_the_input, {
                  disabled: _ctx.additional_services_state.is_loading,
                  value: _ctx.additional_services_state.gridCount,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.additional_services_state.gridCount) = $event)),
                  "is-invalid": _ctx.additional_services_state_form$.gridCount.$error,
                  placeholder: "Количество"
                }, null, 8, ["disabled", "value", "is-invalid"])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_the_button, {
                disabled: 
                            _ctx.data_state.additional_services.is_failed ||
                            _ctx.data_state.additional_services.is_loading ||
                            _ctx.data_state.additional_services.list.length === 0
                        ,
                type: "submit",
                class: "primary small",
                loading: _ctx.additional_services_state.is_loading
              }, {
                default: _withCtx(() => [
                  _hoisted_35,
                  _createTextVNode(" Сохранить ")
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ])
          ], 64))
    ], 32)
  ]))
}